import React, { Fragment } from 'react';

const RequiredSF = () => (
  <Fragment>
    <ul>
      <li>Must be 21+ years of age</li>
      <li>Have a valid in-state driver’s license</li>
      <li>Have an active rideshare driver account (such as Uber) </li>
    </ul>
  </Fragment>
);

export default RequiredSF;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/Eligibility/RequiredSF.js